import React from 'react';

function Icon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='21'
      height='21'
      viewBox='0 0 48 48'
    >
      <path d='M38.982 6.97a2 2 0 00-1.396.616L24 21.172 10.414 7.586A2 2 0 008.98 6.98a2 2 0 00-1.393 3.434L21.172 24 7.586 37.586a2 2 0 102.828 2.828L24 26.828l13.586 13.586a2 2 0 102.828-2.828L26.828 24l13.586-13.586a2 2 0 00-1.432-3.443z'/>
    </svg>
  );
}

export default Icon;
